import { Button } from "antd";
import styles from "./game.module.css";
import { useState, useContext, useEffect } from "react";
import { db } from "../utils/firebase";
import { onValue, ref, set } from "firebase/database";
import { useParams, useNavigate } from "react-router-dom";
import { MyContext } from "../utils/utils";
import Setting from "./Component/setting";
import { SettingFilled } from "@ant-design/icons";
import AllCard from "./Component/allCard";
import MyCard from "./Component/myCard";

const Game = () => {
  const { key } = useParams();
  const [visible, setVisible] = useState(false);
  const showDrawer = () => {
    setVisible(true);
  };

  const [state, setState] = useState(null);
  useEffect(() => {
    onValue(ref(db, "rooms/" + key + "/state"), (snapshot) => {
      const val = snapshot.val();
      setState(val);
    });
  }, [db]);

  return (
    <div className={styles.body}>
      <div className={styles.gameboard}>
        <AllCard state={state} />
        {state == "PLAY" && <MyCard />}
      </div>

      <Setting visible={visible} setVisible={setVisible} />
      <Button
        style={{
          position: "absolute",
          top: "10px",
          right: "20px",
          fontSize: "15px",
        }}
        icon={<SettingFilled />}
        type="link"
        onClick={showDrawer}
      >
        설정
      </Button>
    </div>
  );
};

export default Game;
